export default __webpack_public_path__ + "static/media/thumbnail.8e0547eb.webp";